import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";
import { decreaseIcon, increaseIcon, neutralIcon } from "./svgIcons";

type PortfolioIconProps = {
  name: "caretUp" | "caretDown" | "caretUpDown";
};

export default function PortfolioIcon(props: PortfolioIconProps) {
  const { name, ...restProps } = props;

  const classes = createClasses(styles.icon, styles[name]);

  switch (name) {
    case "caretUp":
      return increaseIcon;
    case "caretDown":
      return decreaseIcon;
    case "caretUpDown":
      return neutralIcon;
    default:
      return <span {...restProps} className={classes} />;
  }
}
